import { render, staticRenderFns } from "./logoutAgreement.vue?vue&type=template&id=0cdfabb1&scoped=true&"
import script from "./logoutAgreement.vue?vue&type=script&lang=js&"
export * from "./logoutAgreement.vue?vue&type=script&lang=js&"
import style0 from "./logoutAgreement.vue?vue&type=style&index=0&id=0cdfabb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdfabb1",
  null
  
)

export default component.exports